import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TopNav from "../components/TopNav";
import { api } from "../lib/api";
import { formatPrice, addToCart } from "../lib/cart";
import { toast } from "sonner";

export default function AccountPage() {
  const nav = useNavigate();
  const [user, setUser] = useState(null);
  const [orders, setOrders] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!localStorage.getItem("aabb_token")) { nav("/login"); return; }
    api.get("/auth/me").then(r => setUser(r.data)).catch(()=>{ localStorage.removeItem("aabb_token"); nav("/login"); });
    api.get("/auth/orders").then(r => setOrders(r.data.orders || [])).catch((e)=>setErr("Could not load orders"));
  }, [nav]);

  const logout = () => { localStorage.removeItem("aabb_token"); localStorage.removeItem("aabb_email"); nav("/"); };

  const handleReorder = (order) => {
    // Add all items from the order back to cart
    order.items.forEach(item => {
      // Skip add-ons (they can be re-selected at checkout)
      if (item.sku.startsWith("ADDON_")) return;

      for (let i = 0; i < item.qty; i++) {
        addToCart({
          sku: item.sku,
          name: item.name,
          price_cents: item.price_cents
        });
      }
    });
    toast.success("Items added to cart");
    nav("/cart");
  };

  const viewInvoice = (orderId) => {
    nav(`/order-success?order=${orderId}`);
  };

  if (!user) return <><TopNav/><div className="aa-shell">Loading…</div></>;

  return (
    <>
      <TopNav />
      <div className="aa-shell">
        <div className="aa-eyebrow">Welcome back</div>
        <h1 className="aa-h1">{user.name || user.email}</h1>
        <p className="aa-sub">{user.email}</p>

        <hr className="aa-hr"/>
        <h2 className="aa-h2">Your orders</h2>
        {orders.length === 0 ? <p className="aa-sub">No orders yet.</p> : (
          <div data-testid="account-orders">
            {orders.map(o => (
              <div key={o.id} className="aa-card" style={{marginBottom:10}}>
                <div style={{display:"flex", justifyContent:"space-between", alignItems:"flex-start"}}>
                  <div>
                    <strong>Order #{o.id.slice(0,8)}</strong>
                    <div className="aa-card-sub">{o.status} · {new Date(o.created_at).toLocaleDateString()}</div>
                  </div>
                  <span style={{color:"var(--gold)", fontFamily:"var(--font-display)", fontSize:"1.2rem"}}>{formatPrice(o.total_cents)}</span>
                </div>
                <div style={{marginTop:8, fontSize:".9rem"}}>
                  {o.items.map((i, idx) => <div key={idx}>· {i.name} × {i.qty}</div>)}
                </div>
                <div style={{display:"flex", gap:"10px", marginTop:"12px"}}>
                  <button
                    className="aa-btn-ghost"
                    onClick={() => handleReorder(o)}
                    style={{padding:"8px 16px", fontSize:".85rem"}}
                    data-testid={`reorder-${o.id}`}
                  >
                    Reorder
                  </button>
                  <button
                    className="aa-btn-ghost"
                    onClick={() => viewInvoice(o.id)}
                    style={{padding:"8px 16px", fontSize:".85rem"}}
                    data-testid={`invoice-${o.id}`}
                  >
                    View Invoice
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
        {err && <div className="aa-error">{err}</div>}
        <div className="aa-bottom">
          <button className="aa-btn-ghost" onClick={logout} data-testid="account-logout">Sign out</button>
        </div>
      </div>
    </>
  );
}
